const AboutApi = {
    info: {
        job_designation: "Software Engineer",
        email: "imufun1@gmail.com",
        country: "Bangladesh",
        githubIcon: "lab la-github",
        linkedinIcon: "lab la-linkedin",
        contactmeIcon: "las la-envelope",
        contactme: "Contact me!",
        contactNumber: "https://wa.me/01734801911",
    },
    introduction: {
        titleTag: {
            icon: "las la-home",
            title: "Introduce",
        },
        hello: "Hi, I'm",
        name: "Imran",
        designation: "Software Engineer",
        tagLine: "The best apps are build with native SDKs"
    },
    about: {
        front_end_title: "Front-End Developer Journey",
        front_end_title_description: "I started journey as a front-end developer & working with HTML, CSS, JavaScript, jQuery, and Bootstrap. I gained practical experience by working on a variety of web projects, my skills in web design and user interface development.",
        ios_title: "Transition to iOS Development",
        ios_description: "I became interested in iOS development and embarked on a new path. I dedicated myself to learning  iOS app development. I established myself as a passionate iOS developer"
    }
}

export default AboutApi